<template>
  <div data-v-5fea6048="" data-v-2ac6a5fc="" class="addMethod">
    <div data-v-5fea6048="" class="content">
      <div data-v-5fea6048="">
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankName">银行名称</label>
          <div data-v-5fea6048="" class="form-input-group" style="position: relative"  @click="changeShow">
            <input data-v-5fea6048="" v-model="banktxt" readonly="" type="text" placeholder="请选择银行" class="" />
            <select style="display: none" data-v-5fea6048="" id="bankName" v-model="bank" class="select-input" @change="changeSelect">
              <option data-v-5fea6048="" v-for="(item, index) in banklist" :key="index" :value="item.id">{{ item.bank_name }}</option>
            </select>
            <span data-v-5fea6048="" class="arrow"></span>
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankCardNo">银行卡号</label>
          <div data-v-5fea6048="" class="form-input-group error">
            <input data-v-5fea6048="" id="bankCardNo" maxlength="19" v-model="bank_no" type="text" placeholder="请输入银行卡号" class="" />
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>
        <div data-v-5fea6048="" class="form-group" style="display: none">
          <label data-v-5fea6048="" for="bankBranchName">姓名</label>
          <div data-v-5fea6048="" class="form-input-group">
            <input data-v-5fea6048="" id="bankBranchName" maxlength="80" v-model="bank_owner" type="text" placeholder="请输入姓名" class="" />
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankBranchName">开户网点</label>
          <div data-v-5fea6048="" class="form-input-group">
            <input data-v-5fea6048="" id="bankBranchName" maxlength="80" type="text" v-model="bank_address" placeholder="请输入开户网点" class="" />
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankBranchName">支付密码</label>
          <div data-v-5fea6048="" class="form-input-group">
            <input data-v-5fea6048="" id="bankBranchName" maxlength="80" type="password" v-model="pay_pass" placeholder="请输入支付密码" class="" />
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>
      </div>
      <div data-v-5fea6048="" class="button-wrapper">
        <button data-v-5fea6048="" class="active" @click="bindCard">保存</button>
      </div>
      <p data-v-5fea6048="" class="add-error-tips">无法绑定？<span data-v-5fea6048="" @click="$parent.openKefu" class="c-yellow">联系客服</span></p>
    </div>
    <van-popup v-model="showbanklst" position="bottom" :style="{ height: '100vh' }">
      <div style="width: 100vw; height: 100vh; background-color: #141414">
        <div class="select-bank-lst-header" style="padding: 10px">
          <p style="color: #fff; font-size: 18px; font-weight: 700; margin-left: 10px">请选择开户银行</p>
          <div class="resarch-box">
            <van-field v-model="value1" placeholder="请输入银行" style="border-radius: 20px; background-color: #000" @input="changeTxt">
              <template #left-icon>
                <van-icon name="search" size="24px" color="#fff" />
              </template>
            </van-field>
          </div>
        </div>
        <div style="width: 100vw; height: calc(100vh - 170px); padding: 10px; overflow-x: hidden; overflow-y: auto">
          <ul>
            <div v-for="(item, index) in banklist" :key="index">
            <li v-if="item.bank_name.indexOf(value1) != -1" class="bank-item"  @click="itemClick(item,index)" :style="tempIndex == index ? 'border-color: #D8A871;color:#D8A871;':''">
              <img :src="item.bank_img" />{{ item.bank_name }}
              <div class="icon" v-show="tempIndex == index">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="#D8A871" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 16.5L32 0V22C32 27.5228 27.5228 32 22 32H0L15 16.5Z" fill="var(--primary-color)"></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M26.2438 17.0091C26.4403 17.1401 26.5767 17.3438 26.623 17.5754C26.6693 17.807 26.6218 18.0475 26.4908 18.2441L20.5533 27.1503C20.4801 27.2598 20.3836 27.3518 20.2707 27.4195C20.1577 27.4873 20.0312 27.5292 19.9001 27.5421C19.769 27.555 19.6367 27.5388 19.5127 27.4944C19.3887 27.4501 19.276 27.3788 19.1829 27.2857L15.6204 23.7232C15.4631 23.5543 15.3774 23.331 15.3815 23.1003C15.3856 22.8696 15.479 22.6494 15.6422 22.4862C15.8054 22.3231 16.0255 22.2296 16.2563 22.2255C16.487 22.2215 16.7103 22.3071 16.8791 22.4644L19.6733 25.2586L25.0088 17.2549C25.14 17.0585 25.3438 16.9224 25.5754 16.8763C25.807 16.8302 26.0474 16.8779 26.2438 17.0091Z"
                    fill="white"
                  ></path>
                </svg>
              </div>
            </li>
            </div>
          </ul>
        </div>
        <div class="select-bank-lst-footer">
          <van-button style="border-color: #7f7a80; background-color: #141414; color: #7f7a80; border-radius: 8px; margin-right: 5px; width: 40%" @click="showbanklst = false">关闭</van-button>
          <van-button style="border-color: #d8a871; background-color: #d8a871; color: #fff; border-radius: 8px; margin-left: 5px; width: 40%" @click="bankSelectOk">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'addBankCard',
  data () {
    return {
      baseURL: '',
      bank: null,
      banktxt: null,
      bank_owner: null,
      pay_pass: null,
      bank_no: null,
      bank_address: null,
      banklist: [],
      value1: null,
      showbanklst: false,
      tmpbanklst: [],
      tempIndex:-1,
      tmpItem:null
    };
  },
  created () {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    that.getBanklist();
  },
  methods: {
    bankSelectOk(){
      this.banktxt = this.tmpItem.bank_name
      this.bank = this.tmpItem.id
      this.showbanklst = false
    },
    itemClick(item,index){
      this.tempIndex = index
      this.tmpItem = item
    },
    changeTxt (val) {
      this.tempIndex = -1
      this.tmpItem = null
    },
    changeShow () {
      this.tempIndex = -1
      this.value1 = null;
      this.tmpItem = null
      this.showbanklst = true;
    },
    changeSelect (val) {
      this.banklist.forEach(element => {
        if (element.id == this.bank) {
          this.banktxt = element.bank_name;
        }
      });
    },
    getBanklist () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/gerSysBankInfo', {}).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.banklist = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    bindCard () {
      let that = this;
      //if (!that.bank_owner) {
      //  that.$parent.showTost(0, '请输入姓名');
      //  return;
      //}
      if (!that.bank) {
        that.$parent.showTost(0, '请输入银行');
        return;
      }
      if (!that.bank_address) {
        that.$parent.showTost(0, '请输入开户行地址');
        return;
      }
      if (!that.bank_no) {
        that.$parent.showTost(0, '请输入银行卡号');
        return;
      }
      if (!that.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (that.bank_no.length < 8) {
        that.$parent.showTost(0, '请输入正确的卡号长度');
        return;
      }
      if (that.pay_pass.length < 6 || that.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输入支付密码长度');
        return;
      }
      that.$parent.showLoading();
      let info = {
        id: that.bank,
        branch: that.bank_address,
        card_number: that.bank_no,
        pay_pass: that.pay_pass,
      };
      that.$apiFun
        .post('/api/bindCard', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            // that.$router.go(-1);
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted () {
    let that = this;
  },
  updated () {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-279436a8.b8591cd3.css';
</style>
<style scoped>
.select-bank-lst-footer {
  text-align: center;
}
li.bank-item {
  position: relative;
  border: 1px solid #7f7a80;
  
  border-radius: 12px;
  height: 42px;
  line-height: 42px;
  margin: 14px 0;
}
li.bank-item img {
  height: 24px;
  margin: 9px;
  float: left;
}
li.bank-item div.icon {
  position: absolute;
  right: -1px;
  bottom: -17px;
}
</style>
<style>
.resarch-box {
  margin-top: 20px;
}
.resarch-box input {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/addBankCard.vue